// Updated component-sticky-cart.js

class StickyCartButton extends HTMLElement {
  constructor() {
    super();
    this.originalButton = document.querySelector('product-form .product-form__submit');
    if (!this.originalButton) return;
    
    this.init();
  }

  init() {
    // Create fixed container at body level
    this.fixedContainer = document.createElement('div');
    this.fixedContainer.className = 'sticky-cart-button';
    
    // Clone the original button
    this.stickyButton = this.originalButton.cloneNode(true);
    this.stickyButton.classList.add('sticky-button');
    
    // Add button to fixed container
    this.fixedContainer.appendChild(this.stickyButton);
    
    // Add fixed container to body
    document.body.appendChild(this.fixedContainer);
    
    this.setupMutationObserver();
    this.handleClick();
  }

  setupMutationObserver() {
    const observer = new MutationObserver(() => {
      this.syncButtons();
    });

    observer.observe(this.originalButton, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  syncButtons() {
    this.stickyButton.disabled = this.originalButton.disabled;
    this.stickyButton.innerHTML = this.originalButton.innerHTML;
  }

  handleClick() {
    this.stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.originalButton.click();
    });
  }
}

customElements.define('sticky-cart-button', StickyCartButton);